import { useState } from "react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { overallBalanceConfig } from "./data";
import { BalanceHeader } from "./components/BalanceHeader";
import { BalanceChart } from "./components/BalanceChart";
import { QuickStatsList } from "./components/QuickStatsList";
import { ViewToggle } from "./components/ViewToggle";

export function OverallBalance() {
  const [view, setView] = useState<BalanceView>("orders");
  const { t } = useTranslation();
  const config = overallBalanceConfig;

  const quickStats = [
    { id: "sales", label: t.crm.totalSales, value: "$14,673", iconName: "shopping-bag" as const, bg: "bg-yellow-soft", color: "text-yellow" },
    { id: "profit", label: t.crm.totalProfit, value: "$9,281", iconName: "dollar" as const, bg: "bg-pink-soft", color: "text-pink" },
    { id: "users", label: t.crm.totalUsers, value: "45.1k", iconName: "users" as const, bg: "bg-teal-soft", color: "text-teal" },
    { id: "expense", label: t.crm.totalExpense, value: "$4,673", iconName: "wallet" as const, bg: "bg-primary-soft", color: "text-primary" },
  ];

  return (
    <div className="card-shadow col-span-full rounded-2xl bg-card p-4 sm:p-6 md:col-span-2">
      <div className="flex items-start justify-between">
        <BalanceHeader
          title={t.crm.overallBalance}
          amount={config.amount}
          trend={t.crm.trend}
        />
        <ViewToggle view={view} onChange={setView} />
      </div>

      <div className="mt-6 flex gap-6">
        <BalanceChart data={config.chartData} activeView={view} />
        <QuickStatsList stats={quickStats} />
      </div>
    </div>
  );
}
